<div *ngIf="loadingFlag" class="black-text">Now Loading</div>
<div class="w-full">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
